import React from 'react'

// Styles
import { Title, Description, Links, StyledLink } from '../Setup2FAModal.styles'

/**
 * AuthAppsStep
 *
 * Renders the first step for the 2FA Setup Modal
 */
export const AuthAppsStep: React.FC = () => {
  return (
    <>
      <Title>Install an Authenticator App</Title>
      <Description>
        First, install and set up an authenticator app on your phone. Once
        you’ve done that, go to the next step. A few example apps:
      </Description>
      <Links>
        <StyledLink
          href="https://apps.apple.com/gb/app/google-authenticator/id388497605"
          isUnderlined
          external>
          Google Authenticator
        </StyledLink>
        <StyledLink
          href="https://apps.apple.com/us/app/authy/id494168017"
          isUnderlined
          external>
          Authy
        </StyledLink>
        <StyledLink
          href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
          isUnderlined
          external>
          Microsoft Authenticator
        </StyledLink>
      </Links>
    </>
  )
}
